import { mountVueComponent } from '@/lib/mount-vue-component';
export default () => {
  import('@/modules/payment-schedule-templates/components/PaymentScheduleTemplateForm.vue').then(PaymentScheduleTemplateForm => {
    mountVueComponent('payment-schedule-template-form', PaymentScheduleTemplateForm);
  });
};
